export const ACTIVITY_COLORS = [
  '#FF6B6B', // Red
  '#4ECDC4', // Teal
  '#45B7D1', // Blue
  '#FDCB6E', // Yellow
  '#6C5CE7', // Purple
  '#FF8A5B', // Orange
  '#2ECC71', // Green
  '#AF7AC5'  // Lavender
];

export enum Category {
  PHYSICAL = 'Physical',
  MENTAL = 'Mental',
  SOCIAL = 'Social',
  CREATIVE = 'Creative',
  EDUCATIONAL = 'Educational'
}

export enum ActivityType {
  EXERCISE = 'Exercise',
  MEDITATION = 'Meditation',
  READING = 'Reading',
  LEARNING = 'Learning',
  HOBBY = 'Hobby'
}

export interface Activity {
  id?: string;
  name: string;
  description?: string;
  date: Date | string;
  category?: Category;
  type?: ActivityType;
  duration?: number;
  color?: string;
  location: string;
  children: string[];
  notes?: string;
  deleted?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface ActivitySuggestion {
  id?: string;
  name: string;
  description?: string;
  category?: Category;
  type?: ActivityType;
  difficulty?: 'Easy' | 'Medium' | 'Hard';
  estimatedDuration?: number;
}

// Mock function for activity recommendations
export function getActivityRecommendations(
  preferences?: Partial<ActivitySuggestion>
): ActivitySuggestion[] {
  const defaultSuggestions: ActivitySuggestion[] = [
    {
      name: 'Morning Yoga',
      description: 'Gentle yoga session to start your day',
      category: Category.PHYSICAL,
      type: ActivityType.EXERCISE,
      difficulty: 'Easy',
      estimatedDuration: 30
    },
    {
      name: 'Reading Hour',
      description: 'Dedicated time for reading a book',
      category: Category.MENTAL,
      type: ActivityType.READING,
      difficulty: 'Easy',
      estimatedDuration: 60
    }
  ];

  // Basic filtering logic
  return defaultSuggestions.filter(suggestion => 
    !preferences || 
    (preferences.category ? suggestion.category === preferences.category : true) &&
    (preferences.type ? suggestion.type === preferences.type : true)
  );
}